export const MODAL_NAME = 'showModalServiceInformation';

export const DEFAULT_VALUES = {
  descriptions: {
    riskGeographic: '',
    riskProfile: '',
    riskOperationType: '',
    riskFinal: ''
  },
  employees: [{ value: 0, label: null }],
  furtherAction: {
    id: null,
    fullName: null,
    dateDecision: null,
    dateCompletion: null,
    decision: ''
  },
  blockDecision: {
    id: null,
    fullName: null,
    dateDecision: null,
    decision: ''
  },
  suspiciousOperation: {
    id: null,
    specialForm: '',
    referralDate: null,
    codeSuspicion: '',
    financeSuspiciousOperations: [{
      dateTransaction: null,
      dealNumber: null
    }],
  },
  dealOperation: {
    dealNumber: null,
    dateTransaction: null,
  },
};

export const useDefaultValues = () => ({
  defaultFurtherAction: DEFAULT_VALUES.furtherAction,
  defaultBlockDecision: DEFAULT_VALUES.blockDecision,
  defaultSuspiciousOperation: DEFAULT_VALUES.suspiciousOperation,
  defaultDealOperation: DEFAULT_VALUES.dealOperation
});

export const CLIENT_FIELDS = {
  LACK_IDENTIFIER_DATA: 'lackIdentifierDataReason',
  OTHER_INFORMATION: 'otherInformation',
  DESCRIPTION: 'description'
}

export const FIELD_TITLES = {
  [CLIENT_FIELDS.LACK_IDENTIFIER_DATA]:
    "Причины отсутствия идентификационных данных и меры, принятые организацией для их получения",
  [CLIENT_FIELDS.OTHER_INFORMATION]:
    "Иные сведения, необходимые для формирования представления о клиенте",
  [CLIENT_FIELDS.DESCRIPTION]: "Дополнительная информация"
};